import { RegisterMobilbytteBytteRequest } from '@app/sales/models/mobilbytte-bytte.model';
import { InsuranceEligibility } from '../../models/equipment-api.model';
import {
  CustomerEquipmentUpgradeAgreement,
  DamageDetails,
  MobileReturnMethod,
} from '../../models/equipment-upgrade-agreement.model';
import { HardwareOfferingWithMobilbytteDTO } from '../../models/mobilephone-variant';

export class ApiGetEquipmentUpgradeAgreementsForCustomerAction {
  static readonly type = '[Mobilbytte] Get equipment upgrade for customer agreements';
  constructor(public customerId: string) {}
}

export class ApiGetEquipmentUpgradeAgreementsForCustomerSuccessAction {
  static readonly type = '[Mobilbytte] Get equipment upgrade agreements for customer success';
  constructor(public existingEquipmentUpgradeAgreements: CustomerEquipmentUpgradeAgreement[]) {}
}

export class ApiGetEquipmentUpgradeAgreementsForCustomerErrorAction {
  static readonly type = '[Mobilbytte] Get equipment upgrade agreements for customer error';
  constructor(public error: string) {}
}

export class ApiRefreshCustomerEquipmentsAction {
  public static readonly type = '[Equipment Api] Refresh customer equipment';
  constructor(public customerId: string) {}
}

export class ApiRefreshCustomerEquipmentsSuccessAction {
  public static readonly type = '[Equipment Api] Refresh customer equipment success';
  constructor(public customerId: string) {}
}

export class ApiRefreshCustomerEquipmentsErrorAction {
  public static readonly type = '[Equipment Api] Refresh customer equipment error';
}

export class ApiValidateAgreementImeiAction {
  public static readonly type = '[Equipment Api] Validate imei on agreement';
  constructor(public agreementId: string) {}
}

export class ApiValidateAgreementImeiSuccessAction {
  public static readonly type = '[Equipment Api] Validate imei on agreement success';
  constructor(
    public agreementId: string,
    public isValidImei: boolean
  ) {}
}

export class ApiValidateAgreementImeiErrorAction {
  public static readonly type = '[Equipment Api] Validate imei on agreement error';
  constructor(
    public agreementId: string,
    public error: string
  ) {}
}

export class SetMobileInsuranceAndReturnDetailsAction {
  public static readonly type = '[Equipment] Set mobile insurance and return details';
  constructor(
    public agreementId: string,
    public redemptionId: number,
    public insuranceEligibilityResponse: InsuranceEligibility,
    public mobileReturnMethod: MobileReturnMethod
  ) {}
}

export class SetClaimIdOnEquipmentUpgradeAgreementAction {
  public static readonly type = '[Equipment] Set claimId on equipment upgrade agreement';
  constructor(
    public agreementId: string,
    public claimId: string
  ) {}
}

export class SetRedemptionIdAction {
  public static readonly type = '[Equipment] Set redemptionId on equipment upgrade agreement';
  constructor(
    public agreementId: number,
    public redemptionId: number
  ) {}
}

export class SetReturnDetailsAction {
  public static readonly type = '[Equipment] Set return details on equipment upgrade agreement';
  constructor(
    public agreementId: number,
    public returnDetails: MobileReturnMethod
  ) {}
}

export class ResetRedemptionDetailsAction {
  public static readonly type = '[Equipment] Reset redemption details on agreement';
  constructor(public agreementId: string) {}
}

export class SetMobileDamageDetailsAction {
  public static readonly type = '[Equipment] Set mobile damage details';
  constructor(
    public agreementId: string,
    public damageDetails: DamageDetails
  ) {}
}

export class ResetMobilBytteState {
  static readonly type = '[Mobilbytte] Reset down payment state';
  constructor() {}
}

export class SetMobileBytteOfferingSelected {
  static readonly type = '[Mobilbytte] Set MobileBytte Offering Selected';
  constructor(public mobilBytteOfferingSelected: HardwareOfferingWithMobilbytteDTO) {}
}

export class ResetSelectedMobilBytteOffering {
  static readonly type = '[Mobilbytte] Reset selected MobileBytte offering';
  constructor() {}
}

export class RegisterMobilBytteBytteAction {
  static readonly type = '[Mobilbytte] Register MobilBytte Bytte';
  constructor(
    public request: RegisterMobilbytteBytteRequest,
    public mobilBytteAgreementId: number
  ) {}
}
